export class FlightAudio {
  constructor() {
    this.context = null;
    this.started = false;
  }

  async start() {
    if (!this.context) this.createGraph();
    await this.context.resume();
    this.started = true;
  }

  createGraph() {
    const Context = window.AudioContext || window.webkitAudioContext;
    this.context = new Context();
    this.master = this.context.createGain();
    this.master.gain.value = 0.36;
    this.master.connect(this.context.destination);

    this.engineGain = this.context.createGain();
    this.engineGain.gain.value = 0.03;
    const engineFilter = this.context.createBiquadFilter();
    engineFilter.type = 'lowpass';
    engineFilter.frequency.value = 480;
    this.engine = this.context.createOscillator();
    this.engine.type = 'sawtooth';
    this.engine.frequency.value = 54;
    this.engine.connect(engineFilter).connect(this.engineGain).connect(this.master);
    this.engine.start();

    const bufferSize = this.context.sampleRate * 2;
    const noiseBuffer = this.context.createBuffer(1, bufferSize, this.context.sampleRate);
    const data = noiseBuffer.getChannelData(0);
    for (let index = 0; index < bufferSize; index += 1) data[index] = Math.random() * 2 - 1;
    this.wind = this.context.createBufferSource();
    this.wind.buffer = noiseBuffer;
    this.wind.loop = true;
    const windFilter = this.context.createBiquadFilter();
    windFilter.type = 'bandpass';
    windFilter.frequency.value = 900;
    windFilter.Q.value = 0.7;
    this.windGain = this.context.createGain();
    this.windGain.gain.value = 0;
    this.wind.connect(windFilter).connect(this.windGain).connect(this.master);
    this.wind.start();
  }

  update(flight) {
    if (!this.started) return;
    const now = this.context.currentTime;
    this.engine.frequency.setTargetAtTime(46 + flight.throttle * 74, now, 0.08);
    this.engineGain.gain.setTargetAtTime(0.035 + flight.throttle * 0.11, now, 0.12);
    this.windGain.gain.setTargetAtTime(Math.min(0.13, flight.speed / 900), now, 0.18);
  }

  tone(frequency, duration = 0.15, gain = 0.12, type = 'sine', delay = 0) {
    if (!this.started) return;
    const start = this.context.currentTime + delay;
    const oscillator = this.context.createOscillator();
    const envelope = this.context.createGain();
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, start);
    envelope.gain.setValueAtTime(0.0001, start);
    envelope.gain.exponentialRampToValueAtTime(gain, start + 0.02);
    envelope.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    oscillator.connect(envelope).connect(this.master);
    oscillator.start(start);
    oscillator.stop(start + duration + 0.03);
  }

  event(type) {
    if (type === 'gun') {
      this.tone(105, 0.06, 0.08, 'square');
    } else if (type === 'missile') {
      this.tone(220, 0.32, 0.12, 'sawtooth');
      this.tone(620, 0.18, 0.07, 'triangle', 0.08);
    } else if (type === 'hit') {
      this.tone(86, 0.18, 0.13, 'square');
    } else if (type === 'destroyed' || type === 'strike' || type === 'crash') {
      this.tone(74, 0.72, 0.24, 'sawtooth');
    } else if (type === 'lock') {
      this.tone(890, 0.08, 0.08, 'square');
    } else if (type === 'victory') {
      [420, 560, 760].forEach((frequency, index) => this.tone(frequency, 0.4, 0.1, 'sine', index * 0.14));
    } else if (type === 'defeat') {
      [220, 170, 112].forEach((frequency, index) => this.tone(frequency, 0.45, 0.1, 'sawtooth', index * 0.16));
    } else if (type === 'merge') {
      this.tone(510, 0.18, 0.1);
      this.tone(720, 0.25, 0.08, 'triangle', 0.12);
    } else if (type === 'ring') {
      this.tone(620, 0.14, 0.14);
      this.tone(930, 0.22, 0.1, 'sine', 0.1);
    } else if (type === 'takeoff') {
      this.tone(410, 0.22, 0.1);
      this.tone(620, 0.3, 0.1, 'sine', 0.16);
    } else if (type === 'near-miss') {
      this.tone(1050, 0.11, 0.12, 'triangle');
    } else if (type === 'landing') {
      [420, 560, 760].forEach((frequency, index) => this.tone(frequency, 0.4, 0.1, 'sine', index * 0.14));
    }
  }
}
